import { EMPTY_ARRAY } from 'constants';
import useEventEffect from 'hooks/useEvent';
import useFetchedData from 'hooks/useFetchedData';
import React, {
  useMemo,
} from 'react';
import { MenuContext } from './constants';

function MenuProvider({ children, restaurantId, isGlobal }) {
  const { data: restaurant } = useFetchedData(
    !isGlobal && restaurantId ? `/v1/restaurants/${restaurantId}/` : null,
    (response = {}) => response?.data,
  );

  const { data: modifiers = [], loading: modifiersLoading, mutate: refreshModifiers } = useFetchedData(
    isGlobal ? 'v1/organizations/{{organizationId}}/global-modifiers/?all=true' : `v1/restaurants/${restaurantId}/modifiers/`,
    isGlobal ? ({ data } = {}) => data?.sort((a, b) => b.id - a.id) || EMPTY_ARRAY :
      (data) => data?.sort((a, b) => b.id - a.id) || EMPTY_ARRAY,
  );

  useEventEffect(() => {
    refreshModifiers();
  }, 'refresh_modifiers');

  const contextValue = useMemo(() => ({
    isGlobal,
    isCatering: isGlobal || Boolean(restaurant?.is_catering),
    modifiers,
    modifiersLoading,
  }), [
    isGlobal,
    restaurant?.is_catering,
    modifiers,
    modifiersLoading,
  ]);

  return (
    <MenuContext.Provider value={contextValue}>
      {children}
    </MenuContext.Provider>
  );
}

export default MenuProvider;
